import { useEffect, useState } from "react"
import { useNavigate } from "react-router"

type Status = "loading" | "authenticated" | "unauthenticated"

export function useAuthRedirect(redirectTo: string) {
  const navigate = useNavigate()
  const [status, setStatus] = useState<Status>("loading")

  useEffect(() => {
    fetch("/users/me", { headers: { Accept: "application/json" } })
      .then(res => {
        if (res.ok) {
          navigate(redirectTo, { replace: true })
        } else {
          setStatus("unauthenticated")
        }
      })
      .catch(() => setStatus("unauthenticated"))
  }, [navigate, redirectTo])

  return status
}
